import { render, staticRenderFns } from "./DashboardDeadline.vue?vue&type=template&id=71d291e2&scoped=true&"
import script from "./DashboardDeadline.vue?vue&type=script&lang=js&"
export * from "./DashboardDeadline.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDeadline.vue?vue&type=style&index=0&id=71d291e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d291e2",
  null
  
)

export default component.exports